<template>
  <span>
    <el-dropdown size="mini" trigger="click" @command="handleCommand">
      <el-button size="mini" :loading="loading">
        Manage
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="onProgress" v-if="request.status === 'P'">
          <span style="color: #E6A23C;">•</span> In Progress
        </el-dropdown-item>
        <el-dropdown-item command="onFulfill">
          <span style="color: #67C23A;">•</span> Fulfilled
        </el-dropdown-item>
        <el-dropdown-item command="onDelete" divided>
          Delete
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog title="Update Status" :visible.sync="dialogVisible">
      <p>This will update the request’s status to <em>fulfilled</em> and email a notification to all voters containing a link to the selected recipe.</p>
      <el-form :model="form" :rules="rules" ref="form" label-width="14rem" label-position="left" @submit.prevent.native="onSubmit('form')">
        <el-form-item label="Fulfilled Recipe" prop="recipeId">
          <el-select v-model="form.recipeId" filterable remote placeholder="Select the recipe associated with this request" :remote-method="getRecipes">
            <el-option v-for="recipe in recipes" :key="recipe.id" :label="recipe.title" :value="recipe.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="onCancel('form')">Cancel</el-button>
          <el-button type="primary" @click="onSubmit">Confirm</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </span>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      recipes: [],
      form: {
        recipeId: '',
      },
      rules: {
        'recipeId': [
          { required: true, message: 'Select the fulfilled recipe.', trigger: 'blur' },
        ],
      }
    }
  },

  props: {
    request: Object,
  },

  methods: {
    handleCommand(command) {
      this[command]()
    },

    async getRecipes(query) {
      if (query.length < 4) {
        return false
      }

      try {
        var { data } = await this.$http.get('/recipes', {
          params: { keyword: query }
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
      }

      this.recipes = data
    },

    async onDelete() {
      try {
        await this.$confirm('The recipe request will be permanently deleted.', 'Confirm Delete', {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })
      } catch(err) {
        return false
      }

      this.loading = true

      try {
        var { data } = await this.$http.delete(`/requests/${ this.request.id }`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.$emit('update')
      this.$message.success(data.message)
    },

    async onProgress() {
      try {
        await this.$confirm('This will update the request status and email a notification to all voters.', 'Confirm Status Change', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'success'
        })
      } catch(err) {
        return false
      }

      this.loading = true

      try {
        var { data } = await this.$http.put(`/requests/${ this.request.id }`, {
          status: 'A'
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.$emit('update')
      this.$message.success(data.message)
    },

    onFulfill() {
      this.dialogVisible = true
    },

    async onSubmit() {
      this.loading = true
      this.dialogVisible = false

      try {
        var { data } = await this.$http.put(`/requests/${ this.request.id }`, {
          status: 'D',
          recipe_id: this.form.recipeId,
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.$emit('update')
      this.$message.success(data.message)
    },

    onCancel(form) {
      this.dialogVisible = false
      this.$refs[form].resetFields()
      this.recipes = []
    },
  },
}
</script>
